<template>
	<el-dialog title="维修申请审批表预览" :visible.sync="dialogVisible" width="90%" :before-close="handleClose"
		class="preview-repair-dialog">
		<div v-loading="loading" class="preview-content">
			<div v-if="repairDetail" id="approval-form" class="approval-form">
				<!-- 琛ㄦ牸 -->
				<table class="approval-table" border="1" cellspacing="0" cellpadding="0">
					<!-- 鏍囬琛?-->
					<tr>
						<td colspan="7">
							<div class="title-cell"> 资中县兴资物业管理有限责任公司维修申请审批表</div>
						</td>
					</tr>

					<!-- 琛ㄥご琛?-->
					<tr>
						<td class="label-cell">申请部门</td>
						<td class="value-cell">物业管理部</td>
						<td class="label-cell">维修地点</td>
						<td class="value-cell" colspan="2">{{ getLocationText() }}</td>
						<td class="label-cell">申请时间</td>
						<td class="value-cell">{{ formatDate(repairDetail.createTime) }}</td>
					</tr>

					<!-- 维修内容及原因附件图片 -->
					<tr>
						<td class="label-cell label-cell-tall">维修内容及<br>原因<br>附件图片</td>
						<td colspan="6" class="content-cell-images">
							<!-- 图片展示区 -->
							<div v-if="getAllImagesList().length > 0" class="image-grid-acceptance">
								<div v-for="(img, index) in getAllImagesList()" :key="'all-' + index"
									class="image-item-acceptance">
									<img :src="img" class="acceptance-image" @error="handleImageError" />
								</div>
							</div>
								<!-- 维修内容文字 - 边框单元格 -->
							<div class="content-text-with-border">
								{{ repairDetail.problemDesc || '-' }}
							</div>
						</td>
					</tr>

					<!-- 报修人员信息 -->
					<tr>
						<td class="label-cell">报修人员</td>
						<td class="value-cell" colspan="2">{{ repairDetail.initiatorName || '-' }}</td>
						<td class="label-cell">联系电话</td>
						<td class="value-cell" colspan="3">{{ repairDetail.initiatorPhone || '-' }}</td>
					</tr>


					<!-- 报价说明 -->
					<tr>
						<td class="label-cell">报价</td>
						<td class="value-cell" colspan="2">{{ gebjjg() }}</td>
						<td class="label-cell">报价备注</td>
						<td class="value-cell" colspan="3"
							style="text-align: left; white-space: pre-wrap; word-break: break-all;">{{ gebjsm() }}</td>
					</tr>


					<!-- 椤圭洰璐熻矗浜烘剰瑙?-->
					<tr>
						<td class="label-cell">项目负责人意见</td>
						<td colspan="6" class="opinion-cell">
							<div v-if="getSignatureByRole('项目')" class="signature-wrapper">
								<img :src="getSignatureByRole('项目')" class="signature-image"
									@error="handleImageError" />
							</div>
						</td>
					</tr>

					<!-- 维修岗负责人意见 -->
					<tr>
						<td class="label-cell">维修岗负责人意见</td>
						<td colspan="6" class="opinion-cell">
							<div class="maintenance-opinion">
								建议<span class="fill-blank">{{ getSupplierName() }}</span>单位进行维修，维修金额控制在<span
									class="fill-blank">{{ getAuditPrice() }}</span>元实施。
							</div>
							<div v-if="getSignatureByRole('维修岗')" class="signature-wrapper">
								<img :src="getSignatureByRole('维修岗')" class="signature-image"
									@error="handleImageError" />
							</div>
						</td>
					</tr>



					<!-- 閮ㄩ棬璐熻矗浜烘剰瑙?-->
					<tr v-if="getSignatureByRole('部门')">
						<td class="label-cell">部门负责人意见</td>
						<td colspan="6" class="opinion-cell">
							<div v-if="getSignatureByRole('部门')" class="signature-wrapper">
								<img :src="getSignatureByRole('部门')" class="signature-image"
									@error="handleImageError" />
							</div>
						</td>
					</tr>

					<!-- 閮ㄩ棬璐熻矗浜烘剰瑙?-->
					<tr v-if="getSignatureByRole('审计')">
						<td class="label-cell">审计意见</td>
						<td colspan="6" class="opinion-cell">
							<div v-if="getSignatureByRole('审计')" class="signature-wrapper">
								<img :src="getSignatureByRole('审计')" class="signature-image"
									@error="handleImageError" />
							</div>
						</td>
					</tr>

					<!-- 分管领导意见 -->
					<tr v-if="getSignatureByRole('分管领导')">
						<td class="label-cell">分管领导意见</td>
						<td colspan="6" class="opinion-cell">
							<div v-if="getSignatureByRole('分管领导')" class="signature-wrapper">
								<img :src="getSignatureByRole('分管领导')" class="signature-image"
									@error="handleImageError" />
							</div>
						</td>
					</tr>

					<!-- 鍓荤粡鐞嗘剰瑙?-->
					<tr v-if="getSignatureByRole('副总经理')">
						<td class="label-cell">副总经理意见</td>
						<td colspan="6" class="opinion-cell">
							<div v-if="getSignatureByRole('副总经理')" class="signature-wrapper">
								<img :src="getSignatureByRole('副总经理')" class="signature-image"
									@error="handleImageError" />
							</div>
						</td>
					</tr>

					<!-- 鎬荤粡鐞嗘剰瑙?-->
					<tr v-if="getSignatureByRole('总经理')">
						<td class="label-cell">总经理意见</td>
						<td colspan="6" class="opinion-cell">
							<div v-if="getSignatureByRole('总经理')" class="signature-wrapper">
								<img :src="getSignatureByRole('总经理')" class="signature-image"
									@error="handleImageError" />
							</div>
						</td>
					</tr>

					<!-- 钁ｄ簨闀匡紙鎵ц钁ｄ簨锛夋剰瑙?-->
					<tr v-if="getSignatureByRole('董事长')">
						<td class="label-cell">董事长（执行董事）意见</td>
						<td colspan="6" class="opinion-cell">
							<div v-if="getSignatureByRole('董事长') || getSignatureByRole('执行董事')"
								class="signature-wrapper">
								<img :src="getSignatureByRole('董事长') || getSignatureByRole('执行董事')"
									class="signature-image" @error="handleImageError" />
							</div>
						</td>
					</tr>
				</table>
			</div>
		</div>

		<span slot="footer" class="dialog-footer">
			<el-button @click="handleClose">关闭</el-button>
			<el-button type="primary" @click="handleExportPDF">导出PDF</el-button>
		</span>
	</el-dialog>
</template>

<script>
	import jsPDF from 'jspdf'
	import html2canvas from 'html2canvas'

	export default {
		name: 'PreviewRepairForm',
		props: {
			visible: {
				type: Boolean,
				default: false
			},
			repairDetail: {
				type: Object,
				default: null
			}
		},
		data() {
			return {
				loading: false,
				parsedSupplierInfoList: [],
				parsedAuditControlInfo: {
					controlNum: '',
					controlRemark: ''
				},
				parsedSignatureList: []
			}
		},
		computed: {
			dialogVisible: {
				get() {
					return this.visible
				},
				set(val) {
					if (!val) {
						this.$emit('close')
					}
				}
			}
		},
		watch: {
			visible(val) {
				// 控制页面滚动
				if (val) {
					document.body.style.overflow = 'hidden'
				} else {
					document.body.style.overflow = ''
				}
			},
			repairDetail: {
				handler(val) {
					if (val) {
						console.log('PreviewRepairForm收到的repairDetail:', val)
						// 解析供应商信息和审价信息
						this.parseRepairDetailData()
					}
				},
				immediate: true,
				deep: true
			}
		},
		methods: {
			handleClose() {
				this.$emit('close')
			},

			// 解析工单详情数据
			parseRepairDetailData() {
				if (!this.repairDetail) return

				console.log('原始repairDetail数据:', this.repairDetail)
				console.log('signPics字段:', this.repairDetail.signPics)

				// 解析供应商信息
				if (this.repairDetail.supplierInfo) {
					this.parsedSupplierInfoList = this.parseSupplierInfoList(this.repairDetail.supplierInfo)
				} else {
					this.parsedSupplierInfoList = []
				}

				// 解析审价信息
				if (this.repairDetail.auditControl) {
					this.parsedAuditControlInfo = this.parseAuditControl(this.repairDetail.auditControl)
				} else {
					this.parsedAuditControlInfo = {
						controlNum: '',
						controlRemark: ''
					}
				}

				// 解析签名列表
				if (this.repairDetail.signPics) {
					this.parsedSignatureList = this.parseSignatureList(this.repairDetail.signPics)
				} else {
					this.parsedSignatureList = []
					console.log('signPics字段不存在或为空')
				}

				console.log('解析后的供应商信息', this.parsedSupplierInfoList)
				console.log('解析后的审价信息:', this.parsedAuditControlInfo)
				console.log('解析后的签名列表:', this.parsedSignatureList)
			},

			// 获取报价说明
			gebjjg() {
				console.log('quoteInfo:', this.repairDetail)
				var str = this.repairDetail.quoteInfo
				var obj = JSON.parse(str)
				return obj.num
			},

			// 获取报价
			gebjsm() {
				var str = this.repairDetail.quoteInfo
				var obj = JSON.parse(str)
				return obj.remark
			},


			// 解析签名列表
			parseSignatureList(signPicsData) {
				if (!signPicsData) return []
				try {
					let dataArray = []
					if (typeof signPicsData === 'string') {
						// 娓呯悊澶氫綑鐨勯楀彿鍜屾牸寮忛棶棰
						let cleanedData = signPicsData
							.replace(/,(\s*[}\]])/g, '$1') // 移除对象/数组结尾的多余逗号
							.replace(/,{2,}/g, ',') // 将多个连续逗号替换为单个逗号
							.replace(/\[,/g, '[') // 移除数组开头的逗号
							.replace(/,\]/g, ']') // 移除数组结尾的逗号

						console.log('清理后的signPics:', cleanedData)

						try {
							signPicsData = JSON.parse(cleanedData)
						} catch (parseErr) {
							console.warn('签名数据解析失败:', parseErr)
							console.warn('原始数据:', signPicsData)
							return []
						}
					}
					if (Array.isArray(signPicsData)) {
						dataArray = signPicsData
					} else if (typeof signPicsData === 'object' && signPicsData !== null) {
						dataArray = [signPicsData]
					} else {
						return []
					}
					const result = []
					for (let item of dataArray) {
						if (typeof item === 'string') {
							try {
								let cleanedItem = item.replace(/,(\s*[}\]])/g, '$1')
								const parsed = JSON.parse(cleanedItem)
								if (parsed && typeof parsed === 'object') {
									result.push(parsed)
								}
							} catch (e) {
								console.warn('解析单条签名信息失败，已跳过:', item, e)
							}
						} else if (typeof item === 'object' && item !== null) {
							result.push(item)
						}
					}
					console.log('最终解析的签名列表:', result)
					return result
				} catch (err) {
					console.warn('解析签名列表失败，已忽略签名信息:', err)
					return []
				}
			},

			// 解析供应商信息垪琛
			parseSupplierInfoList(supplierInfoData) {
				if (!supplierInfoData) return []
				try {
					let dataArray = []
					if (typeof supplierInfoData === 'string') {
						supplierInfoData = JSON.parse(supplierInfoData)
					}
					if (Array.isArray(supplierInfoData)) {
						dataArray = supplierInfoData
					} else if (typeof supplierInfoData === 'object' && supplierInfoData !== null) {
						dataArray = [supplierInfoData]
					} else {
						return []
					}
					const result = []
					for (let item of dataArray) {
						if (typeof item === 'string') {
							try {
								const parsed = JSON.parse(item)
								if (parsed && typeof parsed === 'object') {
									result.push(parsed)
								}
							} catch (e) {
								console.warn('解析供应商信息项失败:', item, e)
							}
						} else if (typeof item === 'object' && item !== null) {
							result.push(item)
						}
					}
					return result
				} catch (err) {
					console.error('解析供应商信息列表失败', err)
					return []
				}
			},

			// 解析审核控价信息
			parseAuditControl(auditControlData) {
				const defaultResult = {
					controlNum: '',
					controlRemark: ''
				}
				if (!auditControlData) {
					return defaultResult
				}
				try {
					let parsed = auditControlData
					if (typeof auditControlData === 'string') {
						parsed = JSON.parse(auditControlData)
					}
					if (typeof parsed === 'object' && parsed !== null) {
						return {
							controlNum: parsed.controlNum || '',
							controlRemark: parsed.controlRemark || ''
						}
					}
					return defaultResult
				} catch (err) {
					console.error('解析审核控价信息失败:', err)
					return defaultResult
				}
			},

			// 从supplierInfoList提取供应商名称，多个用逗号连接
			getSupplierName() {
				if (!this.parsedSupplierInfoList || this.parsedSupplierInfoList.length === 0) {
					return '-'
				}
				// 提取所有供应商名称，用逗号连接
				return this.parsedSupplierInfoList.map(item => item.name || '').filter(name => name).join('，')
			},

			// 从auditControlInfo提取审价金额
			getAuditPrice() {
				return this.parsedAuditControlInfo.controlNum || ''
			},

			// 从signatureList提取指定角色的签名（使用包含匹配）
			getSignatureByRole(roleName) {
				if (!this.parsedSignatureList || this.parsedSignatureList.length === 0) {
					return ''
				}
				// 使用包含匹配：只要签名的roleName包含传入的roleName，或者传入的roleName包含签名的roleName
				const signature = this.parsedSignatureList.find(item => {
					if (!item.roleName) return false
					// 双向包含匹配
					return item.roleName.includes(roleName) || roleName.includes(item.roleName)
				})
				return signature ? signature.img : ''
			},

			// 从problemImgs字符串解析图片URL数组
			getImageList(imgsString) {
				if (!imgsString) {
					return []
				}

				// 如果是字符串格式，先尝试解析JSON
				if (typeof imgsString === 'string') {
					// 如果是JSON格式，解析后获取images字段
					try {
						const parsed = JSON.parse(imgsString)
						if (parsed.images) {
							if (typeof parsed.images === 'string') {
								return parsed.images.split(',').filter(url => url.trim() !== '')
							}
							if (Array.isArray(parsed.images)) {
								return parsed.images.filter(url => url && url.trim() !== '')
							}
						}
						// 如果解析后没有images字段，当作逗号分隔字符串处理
						return imgsString.split(',').filter(url => url.trim() !== '')
					} catch (e) {
						// 不是JSON格式，当作逗号分隔字符串处理
						return imgsString.split(',').filter(url => url.trim() !== '')
					}
				}

				// 如果是数组格式
				if (Array.isArray(imgsString)) {
					return imgsString.filter(url => url && url.trim() !== '')
				}

				return []
			},

			// 合并所有图片（维修前、维修中、维修后）
			getAllImagesList() {
				const beforeImages = this.getImageList(this.repairDetail && this.repairDetail.problemImgs) || []
				const processImages = this.getProcessImageList() || []
				const afterImages = this.getAfterImageList() || []
				const allImages = [...beforeImages, ...processImages, ...afterImages]
				console.log('所有图片URL:', allImages)
				return allImages
			},


			// 获取维修过程图片
			getProcessImageList() {
				if (!this.repairDetail || !this.repairDetail.repairProcessImgs) return []
				try {
					const data = typeof this.repairDetail.repairProcessImgs === 'string' ?
						JSON.parse(this.repairDetail.repairProcessImgs) :
						this.repairDetail.repairProcessImgs

					if (data && data.images) {
						if (typeof data.images === 'string') {
							return data.images.split(',').filter(img => img.trim())
						}
						if (Array.isArray(data.images)) {
							return data.images.filter(img => img && img.trim())
						}
					}

					return []
				} catch (err) {
					console.log('解析维修图片失败:', err)
					return []
				}
			},

			// 获取维修后图片
			getAfterImageList() {
				if (!this.repairDetail || !this.repairDetail.repairAfterImgs) return []
				try {
					let data
					if (typeof this.repairDetail.repairAfterImgs === 'string') {
						data = JSON.parse(this.repairDetail.repairAfterImgs)
					} else {
						data = this.repairDetail.repairAfterImgs
					}

					if (data && data.images) {
						if (typeof data.images === 'string') {
							return data.images.split(',').filter(img => img.trim())
						}
						if (Array.isArray(data.images)) {
							return data.images.filter(img => img && img.trim())
						}
					}
					return []
				} catch (err) {
					console.log('解析验收图片失败:', err)
					return []
				}
			},


			getImageList(imgsString) {
				if (!imgsString || typeof imgsString !== 'string') {
					return []
				}
				return imgsString.split(',').filter(url => url.trim() !== '')
			},


			// 格式化日期为YYYY.M.D格式
			formatDate(dateString) {
				if (!dateString) {
					return ''
				}
				try {
					const date = new Date(dateString)
					const year = date.getFullYear()
					const month = date.getMonth() + 1
					const day = date.getDate()
					return `${year}.${month}.${day}`
				} catch (error) {
					console.error('Date format error:', error)
					return dateString
				}
			},

			// 格式化验收时间为 **年**月**日
			formatAcceptanceDate(dateString) {
				if (!dateString) {
					return '**年**月**日'
				}
				try {
					const date = new Date(dateString)
					const year = date.getFullYear()
					const month = date.getMonth() + 1
					const day = date.getDate()
					return `${year}年${month}月${day}日`
				} catch (error) {
					console.error('Date format error:', error)
					return '**年**月**日'
				}
			},

			// 格式化底部日期为 **年**月**日
			formatFooterDate() {
				return '**年**月**日'
			},

			// 鑾峰彇维修地点鏂囨湰 - 涓庡垪琛ㄩ〉闈繚鎸佷竴鑷
			getLocationText() {
				if (!this.repairDetail) {
					return ''
				}

				// 如果是公区报修(orderType === 1)，使用 addressDetail
				if (this.repairDetail.orderType === 1 || this.repairDetail.orderType === '1') {
					return this.repairDetail.addressDetail || ''
				}
				// 如果是室内报修(orderType === 0)，使用 roomName
				else if (this.repairDetail.orderType === 0 || this.repairDetail.orderType === '0') {
					return this.repairDetail.roomName || ''
				}

				// 默认情况，优先显示 addressDetail，没有则显示 roomName
				return this.repairDetail.addressDetail || this.repairDetail.roomName || ''
			},

			// 图片加载错误处理
			handleImageError(e) {
				e.target.style.display = 'none'
			},

			async handleExportPDF() {
				if (!this.repairDetail) {
					this.$message.warning('没有可导出的数据')
					return
				}

				// 娣诲姞纭鎻愮ず
				try {
					await this.$confirm('确定要导出PDF吗？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'info'
					})
				} catch {
					// 用户取消
					return
				}

				const loadingInstance = this.$loading({
					lock: true,
					text: '正在生成PDF，请稍等...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				})

				try {
					// 获取要转换的DOM元素
					const element = document.getElementById('approval-form')
					if (!element) {
						throw new Error('未找到表格元素')
					}

					// 使用html2canvas将DOM转换为canvas
					const canvas = await html2canvas(element, {
						scale: 2, // 提高清晰度
						useCORS: true, // 允许跨域图片
						allowTaint: true, // 允许跨域图片
						logging: false,
						backgroundColor: '#ffffff'
					})

					// 获取canvas的尺寸
					const imgWidth = 210 // A4纸宽度（mm）
					const imgHeight = (canvas.height * imgWidth) / canvas.width

					// 创建PDF
					const pdf = new jsPDF({
						orientation: imgHeight > imgWidth ? 'portrait' : 'portrait',
						unit: 'mm',
						format: 'a4'
					})

					// 将canvas转换为图片并添加到PDF
					const imgData = canvas.toDataURL('image/jpeg', 1.0)
					pdf.addImage(imgData, 'JPEG', 0, 0, imgWidth, imgHeight)

					// 生成文件名
					const fileName = `${this.repairDetail.orderNo || 'repair'}_维修申请审批表.pdf`

					// 下载PDF
					pdf.save(fileName)

					this.$message.success('PDF生成成功')
				} catch (error) {
					console.error('PDF generation error:', error)
					this.$message.error('PDF生成失败：' + error.message)
				} finally {
					loadingInstance.close()
				}
			}
		}
	}
</script>

<style scoped>
	.preview-repair-dialog>>>.el-dialog {
		max-height: none;
		display: flex;
		flex-direction: column;
	}

	.preview-repair-dialog>>>.el-dialog__body {
		flex: 1;
		overflow: visible;
		padding: 20px;
		background-color: #f0f0f0;
	}

	.preview-content {
		display: flex;
		justify-content: center;
		overflow: visible;
	}

	/* A4纸张尺寸：210mm x 297mm */
	.approval-form {
		background: white;
		width: 210mm;
		height: 297mm;
		padding: 10mm;
		margin: 0 auto;
		box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
		box-sizing: border-box;
	}

	.approval-table {
		width: 100%;
		border-collapse: collapse;
		border: 1px solid #999;
		table-layout: auto;
	}

	.approval-table td {
		border: 1px solid #999;
		padding: 10px 8px;
		font-size: 13px;
		vertical-align: middle;
		word-wrap: break-word;
		line-height: 1.6;
	}

	/* 标题单元格 */
	.title-cell {
		text-align: center;
		font-size: 24px;
		font-weight: bold;
		line-height: 1.2;
		color: #000;
		padding: 6px;
		background-color: #fff;
	}

	.label-cell {
		font-weight: bold;
		text-align: center;
		width: 100px;
		min-width: 100px;
		color: #000;
		background-color: #fff;
	}

	/* 高的标签单元格 */
	.label-cell-tall {
		height: 280px;
		vertical-align: middle;
	}

	.value-cell {
		text-align: center;
		color: #000;
		padding: 8px 10px;
		line-height: 1.6;
	}

	/* 图片内容单元格 */
	.content-cell-images {
		text-align: center;
		vertical-align: top;
		height: 200px;
		padding: 10px !important;
	}

	.content-cell-images .image-grid-acceptance {
		height: 180px;
	}

	/* 紧凑型图片网格 - 3列2行 */
	.image-grid-compact {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: 10px;
		margin-bottom: 12px;
		max-width: 100%;
		min-height: 200px;
		justify-items: center;
	}

	.image-item-compact {
		width: 100%;
		max-width: 180px;
		height: 180px;
		overflow: hidden;
		border: 1px solid #ddd;
		border-radius: 4px;
		background: #f5f5f5;
	}

	.problem-image-compact {
		width: 100%;
		height: 100%;
		object-fit: cover;
		display: block;
	}

	/* 图片网格 - 每行4张自适应 */
	.image-grid-acceptance {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: 10px;
		width: 100%;
	}

	.image-item-acceptance {
		height: 120px;
		overflow: hidden;
		border: none;
		background: #f5f5f5;
	}

	.acceptance-image {
		width: 100%;
		height: 100%;
		object-fit: cover;
		display: block;
	}

	/* 报修内容文字 - 只有上边框 */
	.content-text-with-border {
		text-align: left;
		line-height: 1.8;
		color: #000;
		font-size: 13px;
		margin-top: 12px;
		margin-left: -10px;
		margin-right: -10px;
		padding: 1px 15px;
		border-top: 1px solid #999;
		word-break: break-all;
		min-height: 40px;
		/* 4行省略号 */
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 4;
		line-clamp: 4;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.opinion-cell {
		text-align: left;
		height: 50px;
		padding: 0px 10px !important;
		vertical-align: top;
	}

	/* 报价备注合并单元格 */
	.price-remark-cell {
		padding: 10px 15px !important;
		vertical-align: top;
	}

	.price-section,
	.remark-section {
		display: flex;
		align-items: baseline;
		margin-bottom: 8px;
		line-height: 1.6;
	}

	.remark-section {
		margin-bottom: 0;
	}

	.price-section .label-cell,
	.remark-section .label-cell {
		font-weight: bold;
		min-width: auto;
		width: auto;
		padding-right: 5px;
	}

	.signature-wrapper {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		width: 100%;
	}

	.signature-image {
		height: 50px;
		width: auto;
		display: block;
		object-fit: contain;
	}

	.maintenance-opinion {
		line-height: 2;
		font-size: 13px;
		color: #000;
		padding: 5px 0 0 0;
	}

	.fill-blank {
		display: inline-block;
		min-width: 100px;
		padding: 0 8px;
		border-bottom: 1px solid #000;
		text-align: center;
		margin: 0 3px;
		font-weight: bold;
		color: #000;
	}

	/* 打印样式 */
	@media print {

		.preview-repair-dialog>>>.el-dialog__header,
		.preview-repair-dialog>>>.el-dialog__footer {
			display: none;
		}

		.preview-content {
			background-color: white;
		}

		.approval-form {
			width: 210mm;
			height: 297mm;
			padding: 10mm;
			margin: 0;
			box-shadow: none;
			box-sizing: border-box;
			page-break-after: always;
		}

		.approval-table {
			page-break-inside: avoid;
		}

		.approval-table td {
			page-break-inside: avoid;
		}
	}

	/* 响应式调整 */
	@media screen and (max-width: 900px) {
		.approval-form {
			width: 100%;
			min-height: auto;
			padding: 10mm;
		}
	}
</style>